export const stringHelper = {
  methods: {
    format: function (format) {
      if (!format) return ""
      var args = Array.prototype.slice.call(arguments, 1)
      return format.replace(/{(\d+)}/g, function (match, number) {
        return typeof args[number] != "undefined"
          ? args[number]
          : match
      })
    },

    isNullOrWhiteSpace (input) {
      return !input || !input.trim()
    },
    isEmailValid(email){
      //email regex - might look into a more readable regex in the future
      return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
    },
    getEnumWithSpaces(enumValue){
      return enumValue.replace(/([A-Z])/g, " $1").trim();
    },
    formatToCurrency(amount, currencyCode){
      if (global.Intl !== undefined) {
        this.intl = Intl
      } else {
        this.intl = require("intl")
      }
      let formattedAmount = new this.intl.NumberFormat("en-US", {
        style: "currency",
        currency: currencyCode
      }).format(amount)
      return formattedAmount;
    },
    replace_(inputStr) {
      return inputStr.replace("_", " ");
    },
    formatToCommaDecimal(input){
      return input.toLocaleString('de-DE', { maximumFractionDigits: 3, minimumFractionDigits: 2 });
    }
  }
}
